/**
 * Filtro de exibição da Biblioteca de empresas do builder de grupo econômico.
 *
 * É apenas filtro local de UI (mesmo modelo do seletor de escopo de empresa em
 * `tenant-company-login-selection`): não altera a fonte de dados nem dispara
 * chamada ao backend.
 */

export interface CompanyLibrarySearchable {
  name: string;
  cnpj: string;
}

/** Faixa de diacríticos combinantes gerada pelo `normalize('NFD')`. */
const COMBINING_DIACRITICS = /[\u0300-\u036F]/g;

/** Minúsculas e sem acentos, para a busca por nome ignorar acentuação e caixa. */
export function normalizeSearchText(value: string): string {
  return value.normalize('NFD').replace(COMBINING_DIACRITICS, '').toLowerCase().trim();
}

/** Apenas dígitos, para o CNPJ casar com ou sem máscara. */
export function onlyDigits(value: string): string {
  return value.replace(/\D/g, '');
}

/**
 * Filtra por nome (sem acento, case-insensitive) ou CNPJ (com ou sem máscara).
 * Query vazia devolve a lista original.
 */
export function filterCompanyLibraryItems<T extends CompanyLibrarySearchable>(
  items: readonly T[],
  query: string
): T[] {
  const normalizedQuery = normalizeSearchText(query);
  if (!normalizedQuery) return [...items];

  const digitsQuery = onlyDigits(query);

  return items.filter(item => {
    if (normalizeSearchText(item.name ?? '').includes(normalizedQuery)) return true;
    return digitsQuery.length > 0 && onlyDigits(item.cnpj ?? '').includes(digitsQuery);
  });
}
